import { jwtDecode } from "jwt-decode";
import { store, read } from "./LocalStorage";

export const initUser = (data) => {
  store("cid", data.id);
  store("token", data.token);
}

export const readToken = () => {
  return read("token");
}

export const storeToken = (token) => {
  store("token", token);
}

export const removeLocalStorage = () => {
  localStorage.clear();
}